module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/65f4f96bd6a19bad3ec1d7534372ca48.gif";